export const general_en = {
  'find_walks' : 'Find',
  'create_walk' : 'Create',
  'my_page' : 'My page',
  'chat_page' : 'Chat',
  'public': 'Public',
  'filters': 'Filters',
  'all' : 'All',
  '7_days': '7 days',
  '30_days': '30 days',
  'today': 'Today',
  'yesterday' : 'Yesterday',
  'month': 'Month',
  'week' : 'Week',
  'day' : 'Day',
  'close' : 'Close',
  'choose' : 'Choose',
  'save' : 'Save',
  'cancel' : 'Cancel',
  'send' : 'Send',
  'done' : 'Done',
  'error_message' : 'Error message',
  'message' : 'Message',
  'block' : 'Block ',
  'send_message' : 'Send message',
  'send_friendrequest' : 'Send friend request',
  'add_friend' : 'Add friend',
  'log_out' : 'Log out',
  'log_in' : 'Log in',
  'name' : 'Name',
  'password' : 'Password',
  'email' : 'Email',
  'biography' : 'Biography',
  'language' : 'Language',
  'change_picture' : 'Change profile picture',
  'share_walk' : 'Share walk',
  'add_to_calendar' : 'Add to calendar',
  'copy_walk' : 'Copy walk',
  'edit_walk' : 'Edit walk',
  'remove_walk' : 'Delete walk',
  'save_walk' : 'Save walk',
  'book_walk' : 'Book walk',
  'cancel_your_walk' : 'Cancel walk',
  'cancel_walk' : 'Cancel walk',

  'booked_confirmation_header' : 'Booked walk',
  'walk_is_booked' : 'The walk is booked',
  'chat_with' : 'Chat with',
  'send_link' : 'Send the link to someone you want to share the walk with',
  'copy_link' : 'Copy link',
  'link_is_copied' : 'Copied link',

  'time_passed' : 'Time has passed',
  'accept' : 'Accept',
  'deny' : 'Deny',
  'unblock' : 'Unblock ',
  'unblock_message' : 'Please note that if you unblock a person they will be able to contact and interact with you again.',

  'could_not_load_profile' : 'Could not load the profile, please reload the page or contact Walking Talking if the problem persists',
  'has_shared_profile' : ' has shared a profile with you',
  'share_profile' : 'Share your profile',
  'edit_your_profile' : 'Edit your profile',
  'share_the_profile' : 'Share the profile',
  's_profile' : "'s profile",
  'send_link_profile_message' : 'Send the link below to the person you wish to share it with.',
  'my_profile' : 'My profile',
  'available_walks' : 'Available walks',

  'friendrequest_confirmation' : 'The friend request was sent',

  'PRO_form_confirmation' : 'Thank you for submitting, Walking Talking will get in touch with you shortly.',

  'get_PRO' : 'Get Walking Talking Pro to unlock more features',
  'walking_talking_pro' : ' Walking Talking Pro ',
  'unlock_PRO' : 'to unlock more features',
  'upgrade_contact' : 'Contact us to upgrade',
  'available_functions' : 'Available Pro features',
  'pro_information' : 'Gain access to all features - upgrade your account to Walking Talking Pro now.',
  'pro_promise' : 'We are continuously developing the app and adding more features. If you upgrade your account you will be among the first to try all our upcoming features.',
  'platform_not_capacitor' : 'Download the app or contact Walking Talking to be able to buy access to Pro',
  'or': ' or ',
  'bas' : 'Basic',
  'pro' : 'Pro',
  'business' : 'Business',
  'chat' : 'Chat',
  'create_and_book' : 'Create and book walks',
  'send_private' : 'Send private walks',
  'copy_walks' : 'Copy walks',
  'repeat_walks' : 'Create walk plans',
  'group_walks' : 'Group walks',
  'walking_talking_business' : 'Walking Talking Pro + Business',
  'walking_talking_business_information' : 'Do you and your business or organisation want to create a private network within the app?',
  'pro_plus_business' : 'Walking Talking PRO + Business',
  'own_app_space' : 'Private network within the app',
  'business_support' : 'Business support',
  'pick_network_type' : 'Pick network type',
  'business_type' : 'Business',

  'upload_picture' : 'Upload profile picture',
  'choose_picture' : 'Choose new image',
  'smaller' : 'Zoom in',
  'bigger' : 'Zoom out',
  'rotate_left' : 'Rotate left',
  'rotate_right' : 'Rotate right',

  'get_PRO_message_alert' : 'To be able to create private walks - upgrade your account to Walking Talking PRO',

  'log_in_for_profile' : 'Log in to access the full profile.',

  'visibility' : 'Visibility',
  'only_my_profile' : 'Only my profile',
  'number_of_participants' : 'Participants',
  'walk_type' : 'Walk type',
  'meet_location' : 'Meet at location',
  'audio_walk' : 'Audio walk',
  'audio_location' : 'Audio or meet at location',
  'whoWhen' : 'You:',
  'message_to' : 'Message to ',

  'audiowalk_info' : 'Participants in an audio walk gets access to a private audio room within the app. Whether you want to meet a completely new person, a friend or take a job meeting walking - the audio walk makes it easier for everyone to meet and walk in different places on their own terms.',

'list_my_walks' : 'List',
'not_booked_walk_card' : 'The walk has not been booked - share it',
'clicking_share_button' : 'Send the link to someone you want to share the walk with',

'find_page_network' : 'My networks',
'list_view_walks' : 'Tomorrow',
'second_view_walks' : 'Today',
'inside_networks_top' : 'Choose Network',
'networks_left_select' : 'My networks',
'right_networks_select' : 'Public',
'second_my_networks' : 'My Networks',
'public_toggle_network' : 'Public',
'bottom_filter_button' : 'Filter',

'top_left_text' : 'Network',
'network_members' : 'Members',
'inside_share' : 'Share network',
'share_name_specific' : 'Share',
'qr_code_explanation' : 'Scan the code to become a member or share the link to invite someone else',
'bottom_copy_link' : 'Copy link',
'when_copy_button_pressed' : 'Link has been copied',
'looking_public_network' : 'Join the network',

'oops_couldnotfind_team' : 'Oops - Could not find team invite',
'somethingwrong_team' : 'Something went wrong, contact owner of the network or support at kontakt@walkingtalking.com',
'does_notexist' : 'Does not exist’',
'inactive_team' : 'This network is no longer active.',
'active_member' : 'Active member',
'already_member' : 'You are already a member of ',

'welcome_team' : 'Welcome to ',
'start_walking' : 'You can now start walking with other members in the network',
'view_network' : 'View networks',
'cantsee_team' : 'If the team does not appear in your list, try logging out and in again. If the problem persists contact support at kontakt@walkingtalking.com',
'go_homepage' :'Go to homepage',
'my_walks' : 'My walks',

'my_walk_filter' : 'My walk filter',
'added_to_cal' : 'Added to your calendar',
'wrong_error' : 'Error: ',
'deleted_event' : 'Deleted event',
'created_eventt' : 'Created event',

'available_calendars' : 'Available calendars, choose which you wish to add the walk to.',
'no_calendars' : 'Could not find a calendar',

'type_association' : 'Association',
'type_other' : 'Other',
'confirm_contact' : 'I allow Walking Talking to contact me with offers, news and updates',
'by_clicking_confirm' : "By clicking send you allow Walking Talking's",

}